<template>
  <!-- side columns share the free space equally, so the logo stays centered -->
  <div class="md:hidden grid grid-cols-[1fr_auto_1fr] items-center gap-2 w-full" data-testid="mobile-header">
    <button @click="openMenu" class="justify-self-start cursor-pointer" :class="light ? 'text-[#121419]' : 'text-white'" aria-label="Menu" data-testid="main-header-menu-button">
      <svg class="size-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
        <path d="M2 5h20M2 12h20M2 19h13" />
      </svg>
    </button>
    <div class="flex" data-testid="mobile-header-logo">
      <slot />
    </div>
    <router-link
        v-if="!isOrganizationMember"
        to="/plans"
        class="col-start-3 justify-self-end flex items-center gap-1.5 rounded-full bg-[#6CBFFF] pl-3 pr-4 py-1.5 text-black text-base font-semibold font-['Inter'] whitespace-nowrap max-[360px]:gap-1 max-[360px]:pl-2.5 max-[360px]:pr-3 max-[360px]:py-1 max-[360px]:text-sm"
        :class="{ 'absolute top-[5px] right-[5px]': hasLogo }"
        data-testid="mobile-header-upgrade">
      <StarIcon class="size-4 max-[360px]:size-3.5" aria-hidden="true" />
      <span v-if="isFreePlan">{{ $t('header_upgrade') !== 'header_upgrade' ? $t('header_upgrade') : 'Upgrade' }}</span>
      <span v-else>{{ $t('header_buy_hours') !== 'header_buy_hours' ? $t('header_buy_hours') : 'Buy Hours' }}</span>
    </router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { StarIcon } from '@heroicons/vue/24/solid';
import emitter from "@/services/emitter.service";
import { PlanType } from '@/constants/pricing-page';

export default {
  name: 'MobileHeader',
  components: {
    StarIcon,
  },
  props: {
    // dark burger for light page backgrounds
    light: {
      type: Boolean,
      default: false,
    },
    // with a logo the upgrade pill moves to the page corner so it doesn't crowd the logo;
    // the parent header must be positioned
    hasLogo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('auth', ['authorized']),
    ...mapState('nonpersist', ['user']),
    isFreePlan() {
      const type = this.user?.subscription?.type;
      return !this.authorized || !type || [PlanType.BASIC, PlanType.SORENSON_FREE_TRIAL].includes(type);
    },
    // hours for organization members are managed by the organization
    isOrganizationMember() {
      return this.authorized && !!this.user?.organization?.id;
    },
  },
  methods: {
    openMenu() {
      emitter.emit('open-account-popup');
    },
  },
}
</script>
